import {useAppSelector} from "../../../../../../../redux/hooks";
import {
  isMySongsPageSelectedSongDetailsRequestComplete
} from "../../../../../modules/my-songs-page-store/mySongsPage.selectors";

export interface IWhenSongDetailsNotLoadedLogic {
  isConditionPassed: boolean;
}

export const useWhenSongDetailsNotLoadedLogic = (): IWhenSongDetailsNotLoadedLogic => {
  const isConditionPassed = !useAppSelector(isMySongsPageSelectedSongDetailsRequestComplete);
  return {
    isConditionPassed,
  };
}
